"use strict";

// Export a simple promise to sleep for some amount of time.
export const sleep = function (ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
};
